import React from 'react';
import { ApLoaderDefault, ApLoaderText } from '@alixpartners/ui-components';
import { RegionalData } from './RegionalData';
import { QueryStringContext } from 'contexts/QueryStringContext';
import { Wrapper } from './RegionalData.styles';
import { convertToArray } from 'Details/utils';
import { getSpendTypeFromBreadcrumbs } from '../../utils';
import { STATES_MAP_CODES } from '../utils';
import { CATEGORY_OPTIONS } from '../../constants';
import { getRegionsData, getRegionalTailSpend } from 'utils/apiRequests';
import isEqual from 'lodash/isEqual';

export class RegionalDataContainer extends React.Component {
	state = {
		categoryType: CATEGORY_OPTIONS[0].value,
		data: [],
		tailSpendData: [],
		isLoading: false,
	};

	componentDidMount() {
		const { showTailSpend, spendType } = this.props;

		this.fetchData();

		if (showTailSpend && spendType !== 0) {
			this.fetchTailSpend();
		}
	}

	componentWillUnmount() {
		this.unmounted = true;
	}

	componentDidUpdate(prevProps) {
		const {
			dimension,
			queryParams,
			selectedCountry,
			selectedState,
			showTailSpend,
			spendType,
		} = this.props;

		if (
			selectedCountry !== prevProps.selectedCountry ||
			selectedState !== prevProps.selectedState ||
			dimension.value !== prevProps.dimension.value ||
			!isEqual(queryParams, prevProps.queryParams)
		) {
			this.fetchData();

			if (showTailSpend && spendType !== 0) {
				this.fetchTailSpend();
			}
		}

		if (
			showTailSpend !== prevProps.showTailSpend ||
			(spendType !== prevProps.spendType && spendType === 0)
		) {
			if (showTailSpend && spendType !== 0) {
				this.fetchTailSpend();
			} else {
				this.setState({ tailSpendData: [] });
			}
		}
	}

	changeCategoryType = e => {
		const categoryType = e.target.value;

		this.setState({ categoryType });
	};

	getApiParams = () => {
		const {
			dimension,
			queryParams,
			selectedCountry,
			selectedState,
		} = this.props;
		const isPurchasing = dimension.value === 'purchasing';
		const countryFilter = `${dimension.value}Country`;
		const stateFilter = `${dimension.value}State`;

		return {
			...queryParams,
			isPurchasing,
			filters: [
				...queryParams.filters,
				...(selectedCountry ? [countryFilter] : []),
				...(selectedState ? [stateFilter] : []),
			],
			filterValues: [
				...queryParams.filterValues,
				...(selectedCountry ? [selectedCountry] : []),
				...(selectedState ? [selectedState] : []),
			],
		};
	};

	getCategoryDimension = () => {
		const { categoryType } = this.state;
		const { queryParams } = this.props;

		if (categoryType !== 'category') {
			return categoryType;
		}

		const level = Math.min(queryParams.hierarchy.length + 1, 4);

		return `categoryL${level}`;
	};

	fetchData = () => {
		this.setState({ isLoading: true });

		return getRegionsData(this.getApiParams())
			.then(data => {
				if (this.unmounted) return;
				this.setState({
					data,
					isLoading: false,
				});
			})
			.catch(() => {
				if (this.unmounted) return;
				this.setState({ isLoading: false });
			});
	};

	fetchTailSpend = () => {
		return getRegionalTailSpend(this.getApiParams()).then(tailSpendData => {
			if (this.unmounted) return;
			this.setState({
				tailSpendData,
			});
		});
	};

	handleExport = () => {
		const { onExport, spendType, selectedCountry, showTailSpend } = this.props;
		const showState = !!STATES_MAP_CODES[selectedCountry];

		onExport({
			...this.getApiParams(),
			...(spendType !== 0 ? { includeTailSpend: !showTailSpend } : {}),
			includeState: showState,
			dimension: this.getCategoryDimension(),
		});
	};

	render() {
		const { categoryType, isLoading, data, tailSpendData } = this.state;
		const {
			companies,
			currencySymbol,
			selectedCountry,
			selectedState,
			queryParams,
			spendType,
			dimension,
			showTailSpend,
			pmiBreadcrumbs,
			showExplorePage,
		} = this.props;

		if (isLoading) {
			return (
				<Wrapper>
					<ApLoaderDefault loaderText={() => <ApLoaderText />} />
				</Wrapper>
			);
		}

		return (
			<RegionalData
				categoryType={categoryType}
				changeCategoryType={this.changeCategoryType}
				data={data}
				tailSpendData={tailSpendData}
				companies={companies}
				currencySymbol={currencySymbol}
				selectedCountry={selectedCountry}
				selectedState={selectedState}
				queryParams={queryParams}
				spendType={spendType}
				dimension={dimension}
				showTailSpend={showTailSpend}
				onExport={this.handleExport}
				pmiBreadcrumbs={pmiBreadcrumbs}
				showExplorePage={showExplorePage}
			/>
		);
	}
}

export default props => (
	<QueryStringContext.Consumer>
		{({ companies, pmiBreadcrumbs, showTailSpend }) => (
			<RegionalDataContainer
				companies={convertToArray(companies)}
				spendType={getSpendTypeFromBreadcrumbs(pmiBreadcrumbs)}
				showTailSpend={showTailSpend === 'true'}
				{...props}
			/>
		)}
	</QueryStringContext.Consumer>
);
